import { useState, useEffect } from 'react'
import { NpsDesktop, NpsMobile } from './style'

const NpsColorScale = ({
  value,
  onChange,
  width = '100%',
  height = '40px',
  mobileHeight = '50px',
  fontSize = '24px',
  responsive = true,
  colorTheme = 'colorful'
}) => {
  const [, setIsMobile] = useState(window.innerWidth <= 768)

  useEffect(() => {
    if (!responsive) return

    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768)
    }

    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [responsive])

  const colorfulColors = {
    0: '#B72224',
    1: '#D52029',
    2: '#E95223',
    3: '#EA6F22',
    4: '#F6A726',
    5: '#FDC729',
    6: '#EBDB0A',
    7: '#E7E145',
    8: '#C2D234',
    9: '#AEC93C',
    10: '#66B44E'
  }

  const grayscaleColors = {
    0: '#181818',
    1: '#282828',
    2: '#383838',
    3: '#484848',
    4: '#585858',
    5: '#686868',
    6: '#787878',
    7: '#888888',
    8: '#989898',
    9: '#A8A8A8',
    10: '#B8B8B8'
  }

  const colors = colorTheme === 'grayscale' ? grayscaleColors : colorfulColors

  const getItemStyle = (item, isVertical = false) => ({
    backgroundColor: colors[item],
    color: '#fff',
    width: isVertical && responsive ? '100%' : width,
    height: isVertical && responsive ? mobileHeight : height,
    textAlign: 'center',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontFamily: "'Helvetica', 'Arial', sans-serif",
    fontWeight: '600',
    fontSize,
    border: value === item.toString() ? '1px solid #333' : 'none'
  })

  const handleItemClick = (item) => {
    if (onChange) {
      onChange(item.toString())
    }
  }

  if (!responsive) {
    return (
      <div style={{ display: 'flex', flexDirection: 'row', gap: '3px' }}>
        {[...Array(11).keys()].map((item) => (
          <div
            key={item}
            onClick={() => handleItemClick(item)}
            style={getItemStyle(item)}
          >
            {item}
          </div>
        ))}
      </div>
    )
  }

  return (
    <div>
      <NpsDesktop>
        {[...Array(11).keys()].map((item) => (
          <div
            key={item}
            onClick={() => handleItemClick(item)}
            style={getItemStyle(item)}
          >
            {item}
          </div>
        ))}
      </NpsDesktop>

      <NpsMobile>
        {[...Array(11).keys()].reverse().map((item) => (
          <div
            key={item}
            onClick={() => handleItemClick(item)}
            style={getItemStyle(item, true)}
          >
            {item}
          </div>
        ))}
      </NpsMobile>
    </div>
  )
}

export default NpsColorScale
